export const getLatestSOCartSelector = (state) => state.personalizeOfferReducer.getLatestSOCartReducer;
